import React, { useState } from 'react';
import { Modal, ModalContent, ModalBody, ModalHeader } from '@/components/modal';

interface DeleteOfferConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  offerNumber: string;
}

const DeleteOfferConfirmationModal: React.FC<DeleteOfferConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  offerNumber
}) => {
  const [inputValue, setInputValue] = useState<string>('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const isConfirmButtonEnabled = inputValue === offerNumber;

  return (
    <Modal open={open} onClose={onClose} className="!flex items-center justify-center">
      <ModalContent className="max-w-md w-full p-6">
        <ModalHeader className="p-0 border-0">
          <div className="flex items-center justify-between flex-wrap grow gap-5 pb-5">
            <h1 className="text-lg font-semibold leading-none text-gray-900">Angebot löschen</h1>
            <button className="btn btn-sm btn-light" onClick={onClose}>
              Schließen
            </button>
          </div>
        </ModalHeader>

        <ModalBody className="scrollable-y py-0 mb-5 ps-0 pe-3 -me-5.5">
          <p className="text-sm text-gray-700 pb-3">
            Möchten Sie das Angebot{' '}
            <span className="font-semibold text-gray-900">{offerNumber}</span> wirklich löschen?
            Diese Aktion kann nicht rückgängig gemacht werden. Bitte geben Sie zur Bestätigung die
            Angebotsnummer ein.
          </p>

          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Angebotsnummer zur Bestätigung eingeben"
            className="border border-gray-400 p-3 rounded-md text-sm w-full focus:outline-none"
          />

          <div className="flex justify-end gap-2 mt-4">
            <button className="btn btn-sm btn-light" onClick={onClose}>
              Abbrechen
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={onConfirm}
              disabled={!isConfirmButtonEnabled}
            >
              Endgültig löschen
            </button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export { DeleteOfferConfirmationModal };
